export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_image') || '图片',
    field: 'defaultImage',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 70,
    slots: { default: 'defaultImage' },
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displaySampleName') || '产品名称',
    field: 'displaySampleName',
    minWidth: 280,
    align: 'left',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySampleName' },
  },
  {
    title: that.$l('table_label_displaySample') || '品类/来源/尺寸',
    field: 'displaySample',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySample' },
  },
  {
    title: that.$l('table_label_expoSampleStatus') || '展品状态',
    field: 'expoSampleStatus',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'expoSampleStatus' },
  },
  {
    title: that.$l('table_label_displayName') || '展品品牌/名称',
    field: 'displayName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_expoSampleDesc') || '展品描述',
    field: 'expoSampleDesc',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expoSampleSpec') || '展品尺寸',
    field: 'expoSampleSpec',
    minWidth: 140,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayFabric') || '展品面料',
    field: 'displayFabric',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFabric' },
  },
  {
    title: that.$l('table_label_remark') || '展品备注',
    field: 'remark',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayScm') || '成品价/工厂',
    field: 'displayScm',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayScm' },
  },
  {
    title: that.$l('table_label_displayQuoted') || '报价方式/参考报价',
    field: 'displayQuoted',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayQuoted' },
  },
  {
    title: that.$l('table_label_modifyInfo') || '修改人',
    field: 'modifyInfo',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
